import PrefixEnum from '../prefixes'

export default Object.freeze({
    'sophia-thiel.gymondo.fitness': PrefixEnum.SOPHIA_THIEL,
})
